import React from 'react';
import {
  AppBar,
  makeStyles,
  Toolbar,
  Badge,
  IconButton,
  Button,
  Typography
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { appProfileSelector } from 'redux/selectors';
import { FormattedMessage } from 'react-intl';
import useRouter from 'utils/useRouter';
import TabImage from 'assets/images/tabimage.png';
import { ReactComponent as IconCart } from 'assets/svgs/product_cart.svg';
import { drawerWidth, drawerCloseWidth } from '../NavBar'
import { ROLE_APAVE_CLIENT, ROLE_ADMIN } from 'config';
import ClientSelection from './clientselect';
import { ReactComponent as IconBusiness } from 'assets/svgs/business.svg';
import PropTypes from 'prop-types';

export const topbar_height = 64

const useStyles = makeStyles(theme => ({
  appBar: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    height: 64,
    minHeight: 'auto',
    boxShadow: '0 3px 3px -1px rgb(0 0 0 / 20%)',
    transition: 'all .5s ease',
    backgroundColor: 'white'
  },
  toolbar: {
    flex: 1,
    alignItems: 'flex-end',
    paddingLeft: '2%',
    paddingRight: '2%',
    backgroundColor: theme.palette.app.primary,
    marginBottom: 10,
    minHeight: 'unset !important'
  },
  logo: {
    height: 30,
  },
  divider: {
    width: 1,
    backgroundColor: '#868aa8',
    height: '40%',
    margin: '0 5px',
  },
  name: { whiteSpace: 'nowrap', color: '#868aa8' },
  middle: {
    whiteSpace: 'nowrap',
    color: '#868aa8',
    flex: 1,
    fontWeight: 'bold',
    textAlign: 'right'
  },
  middleLogo: {
    height: 30,
  },
  avatar: {
    width: 32,
    height: 32,
    fontSize: 14,
    backgroundColor: theme.palette.text.primary,
  },
  lng: {
    width: 32,
    height: 32,
    fontSize: 14,
    backgroundColor: theme.palette.app.primary,
  },
  langBtn: {
    color: 'white',
    border: `2px solid white`,
    borderRadius: 10,
    padding: `4px 8px`,
    marginBottom: 6,
    minWidth: 'unset',
    fontSize: 12,
    fontWeight: 'bold'
  },
  clientBtn: {
    margin: theme.spacing(0, 4, 0, 2),
    color: '#6CB570',
    backgroundColor: 'white',
    borderRadius: 10,
    borderBottomLeftRadius: '0px !important',
    borderBottomRightRadius: '0px !important',
    fontSize: 12,
    fontWeight: 'bold',
    padding: '6px 12px',
    '&:hover': {
      backgroundColor: 'white !important'
    }
  },
  clientBtnLabel: {
    display: 'block'
  },
  indicator: {
    width: 65,
    height: 5,
    backgroundColor: '#6CB570',
    borderRadius: 10,
    marginRight: 'auto',
    marginLeft: 'auto',
    marginTop: 4
  },
  tabButton: {
    color: theme.palette.app.primary,
    backgroundImage: `url(${TabImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    padding: '5px 50px',
    backgroundColor: 'rgba(38, 50, 56, 0.04)'
  },
  InactivetabButton: {
    color: 'white',
    textTransform: 'none',
    marginBottom: 3,
    marginRight: theme.spacing(2)
  },
  iconbutton: {
    color: theme.palette.text.primary,
    fontWeight: '600',
    textTransform: 'none'
  },
  btnIcon: {
    fill: theme.palette.app.primary,
    width: 20,
    height: 20
  },
  badge: {
    backgroundColor: 'white',
    color: 'red',
    right: 23,
    fontSize: 8,
    top: 13,
    width: 16,
    height: 16,
    minWidth: 16
  },
  iconWrap: {
    width: 35,
    height: 35,
    backgroundColor: 'white',
    borderRadius: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  clientSelect: {
    margin: theme.spacing(0, 1),
    width: 200,
    borderRadius: 8,
    backgroundColor: 'white',
    marginBottom: 2
  },
  rootclientSelect: {
    paddingTop: 12,
    paddingBottom: 12
  }
}));

const APAVEIMAGE = require('assets/images/apave.png');

const TopBar = ({ openDrawer, location }) => {
  const classes = useStyles();
  const { apaveProducts } = useSelector(state => state.cart)

  const router = useRouter();

  const { role } = useSelector(appProfileSelector);


  const [anchorEl, setAnchorEl] = React.useState(null);
  const openClient = Boolean(anchorEl);
  const popover_id = openClient ? 'simple-popover' : undefined;
  const [clientName, setClientName] = React.useState("");

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <AppBar
      elevation={0}
      position="fixed"
      color="default"
      className={classes.appBar}
      style={!openDrawer ? {
        marginLeft: drawerCloseWidth,
        width: `calc(100% - ${drawerCloseWidth}px)`
      } : {}}
    >
      <Toolbar className={classes.toolbar}>
        <Button className={classes.tabButton}>
          <img src={APAVEIMAGE} alt="apave" className={classes.logo} />
        </Button>
        <Button className={classes.InactivetabButton}>
          Espace Client
        </Button>
        <a
          href="https://console-espaceclient.apave.com/doc/Politique de protection des données personnelles_Espace Client.pdf"
          target="_blank"
          style={{ color: "white", fontSize: 13, marginBottom: 13, }}
        >
          <strong><FormattedMessage id="policy" /></strong>
        </a>
        {
          (role == ROLE_APAVE_CLIENT || role == ROLE_ADMIN) &&
          <>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <IconButton
              aria-describedby={"simple-popover"}
              onClick={handleClick}
              size="small"
              style={{ marginBottom: 7 }}
            >
              <IconBusiness style={{ fill: "white" }} />
            </IconButton>
            <Typography style={{ color: 'white', marginBottom: 10, marginLeft: 10 }}>{clientName}</Typography>
            <ClientSelection
              id={popover_id}
              open={openClient}
              anchorEl={anchorEl}
              handleClose={handleClose}
              setClientName={setClientName}
            />
          </>
        }
        <div className={classes.middle}>
          {
            !(location.pathname?.includes("/pack-sanitaire")) && role != ROLE_APAVE_CLIENT &&
            < Badge badgeContent={apaveProducts.length} classes={{ badge: classes.badge }}>
              <Button
                startIcon={
                  <div className={classes.iconWrap}>
                    <IconCart className={classes.btnIcon} />
                  </div>}
                className={classes.iconbutton}
                onClick={() => router.history.push('/carts')}>
              </Button>
            </Badge>
          }
        </div>
        <div>
          <Button
            classes={{
              root: classes.clientBtn,
              label: classes.clientBtnLabel
            }}
          >
            {'Espace client'}
            <div className={classes.indicator} />
          </Button>
        </div>
      </Toolbar>
    </AppBar >
  );
};

TopBar.propTypes = {
  openDrawer: PropTypes.bool,
  location: PropTypes.any
};

export default TopBar;
